import { render, staticRenderFns } from "./TaishokutodokeEdit.vue?vue&type=template&id=1cef3830&scoped=true"
import script from "./TaishokutodokeEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaishokutodokeEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TaishokutodokeEdit.vue?vue&type=style&index=0&id=1cef3830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef3830",
  null
  
)

export default component.exports